@if (v()) {
  <div class="tiny flex-container align-center" [ngClass]="classEcartSurcout()">
    @if (sig()) {
      {{ v() > 0 ? "+" : "" }}{{ v() | numberSig:{ defaultSig: 3 } }}
    } @else {
      {{ (v() > 0 ? "+" : "") + v().toFixed(2) }}
    }
    {{ (valeurUnite() ? " " + valeurUnite() : " €") }}
  </div>
}
